import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { SessionService } from '../services';
import { hasSessionHint } from '../utils/auth-hint';

export const guestGuard: CanActivateFn = () => {
  const session = inject(SessionService);
  const router = inject(Router);

  if (session.user) {
    return router.createUrlTree(['/']);
  }

  if (session.authChecked) {
    return true;
  }

  return hasSessionHint() ? router.createUrlTree(['/']) : true;
};
